import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhotoAlbumComponent } from "../../_components/photo-album/photo-album.component";

@Component({
  selector: 'app-on-the-road',
  templateUrl: './on-the-road.component.html',
  styleUrls: ['./on-the-road.component.scss'],
  imports: [CommonModule, PhotoAlbumComponent]
})
export class OnTheRoadComponent implements OnInit {

  photosDFMC2025 = [];
  photosCMP2025 = [];
  photosNACPA2026 = [];
  photosCCOC50 = [];
  photosSMPEP = [];

  constructor() { }

  ngOnInit() {
    //this.photos.push({src:'', title:'', description:''});

    this.photosDFMC2025.push({src:'https://services.ifa.com/art/images/3577_2026-4-21-13-51-29.jpg', title:'', description:''});
    this.photosDFMC2025.push({src:'https://services.ifa.com/art/images/3577_2026-4-21-13-51-35.jpg', title:'', description:''});
    this.photosDFMC2025.push({src:'https://services.ifa.com/art/images/3577_2026-5-6-14-22-56.jpg', title:'', description:''});
    this.photosDFMC2025.push({src:'https://services.ifa.com/art/images/3577_2026-5-6-14-22-47.jpg', title:'', description:''});
    this.photosDFMC2025.push({src:'https://services.ifa.com/art/images/3577_2026-5-6-14-23-5.jpg', title:'', description:''});
    
    // this.photosDFMC2025.push({src:'', title:'', description:''});
    // this.photosDFMC2025.push({src:'', title:'', description:''});

    this.photosCMP2025.push({src:'https://services.ifa.com/art/images/3577_2026-5-1-14-48-9.jpg', title:'', description:''});
    this.photosCMP2025.push({src:'https://services.ifa.com/art/images/3577_2026-5-1-14-48-20.jpg', title:'', description:''});
    this.photosCMP2025.push({src:'https://services.ifa.com/art/images/3577_2026-5-1-14-48-31.jpg', title:'', description:''});
    this.photosCMP2025.push({src:'https://services.ifa.com/art/images/3577_2026-5-1-14-48-40.jpg', title:'', description:''});
    this.photosCMP2025.push({src:'https://services.ifa.com/art/images/3577_2026-5-6-14-19-34.jpg', title:'', description:''});
    this.photosCMP2025.push({src:'https://services.ifa.com/art/images/3577_2026-5-6-14-19-24.jpg', title:'', description:''});
    this.photosCMP2025.push({src:'https://services.ifa.com/art/images/3577_2026-5-6-14-19-42.jpg', title:'', description:''});
    this.photosCMP2025.push({src:'https://services.ifa.com/art/images/3577_2026-5-6-14-19-54.jpg', title:'', description:''});


    this.photosNACPA2026.push({src:'https://services.ifa.com/art/images/3577_2026-5-1-14-43-59.jpg', title:'', description:''});
    this.photosNACPA2026.push({src:'https://services.ifa.com/art/images/3577_2026-5-1-14-44-8.jpg', title:'', description:''});
    this.photosNACPA2026.push({src:'https://services.ifa.com/art/images/3577_2026-5-1-14-45-4.jpg', title:'', description:''});
    this.photosNACPA2026.push({src:'https://services.ifa.com/art/images/3577_2026-5-1-14-44-53.jpg ', title:'', description:''});
    this.photosNACPA2026.push({src:'https://services.ifa.com/art/images/3577_2026-5-1-14-44-45.jpg', title:'', description:''});
    this.photosNACPA2026.push({src:'https://services.ifa.com/art/images/3577_2026-5-1-14-44-38.jpg', title:'', description:''});
    this.photosNACPA2026.push({src:'https://services.ifa.com/art/images/3577_2026-5-1-14-44-31.jpg', title:'', description:''});
    this.photosNACPA2026.push({src:'https://services.ifa.com/art/images/3577_2026-5-1-14-44-24.jpg', title:'', description:''});
    this.photosNACPA2026.push({src:'https://services.ifa.com/art/images/3577_2026-5-1-14-44-15.jpg', title:'', description:''});
    //this.photosNACPA2026.push({src:'', title:'', description:''});
    // this.photosNACPA2026.push({src:'', title:'', description:''});

    this.photosCCOC50.push({src:'https://services.ifa.com/art/images/3577_2026-6-8-14-37-4.jpg', title:'', description:''});
    this.photosCCOC50.push({src:'https://services.ifa.com/art/images/3577_2026-6-8-14-36-55.jpg', title:'', description:''});
    //this.photosCCOC50.push({src:'', title:'', description:''});
    //this.photosCCOC50.push({src:'', title:'', description:''});

    this.photosSMPEP.push({src:'https://services.ifa.com/art/images/3577_2026-6-8-14-46-20.jpg', title:'', description:''});
    //this.photosSMPEP.push({src:'https://services.ifa.com/art/images/3577_2026-6-8-14-46-57_200h.jpg', title:'', description:''});
    this.photosSMPEP.push({src:'https://services.ifa.com/art/images/3577_2026-6-8-14-46-47.jpg', title:'', description:''});
    this.photosSMPEP.push({src:'https://services.ifa.com/art/images/3577_2026-6-8-14-46-39.jpg', title:'', description:''});
    this.photosSMPEP.push({src:'https://services.ifa.com/art/images/3577_2026-6-8-14-46-27.jpg', title:'', description:''});
  }


}
